export default __webpack_public_path__ + "static/media/Dashboard.d7adfc6b.svg";